"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityBufferStore = void 0;
const rc_js_util_1 = require("rc-js-util");
/**
 * @public
 */
class EntityBufferStore {
    constructor() {
        this.bufferLayouts = new Map();
    }
    clearLayout(entity, groupId) {
        const byId = this.bufferLayouts.get(entity);
        if (byId != null) {
            byId.delete(groupId);
        }
    }
    clearLayouts(entity) {
        this.bufferLayouts.delete(entity);
    }
    getLayout(entity, groupId) {
        const byId = this.bufferLayouts.get(entity);
        if (byId == null) {
            return undefined;
        }
        return byId.get(groupId);
    }
    setNewLayout(entity, groupId, bufferLayout) {
        const byId = rc_js_util_1._Map.initializeGet(this.bufferLayouts, entity, () => new Map());
        if (byId.has(groupId)) {
            return false;
        }
        byId.set(groupId, bufferLayout);
        return true;
    }
    getAllLayouts() {
        const groupedLayouts = rc_js_util_1._Map.arrayMap(this.bufferLayouts, bufferLayout => rc_js_util_1._Map.valuesToArray(bufferLayout));
        return rc_js_util_1._Array.flatMap(groupedLayouts, (groupedLayout) => groupedLayout);
    }
    getLayouts(entity) {
        return this.bufferLayouts.get(entity);
    }
}
exports.EntityBufferStore = EntityBufferStore;
//# sourceMappingURL=entity-buffer-store.js.map